import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Grid from "./Grid";
import { Heading } from "@miro-site/core";
import Highlighted from "./Highlighted";
import SecondaryNavigationItem from "./SecondaryNavigationItem";
import styled, { useTheme } from "styled-components";
var TemplatesNavGrid = styled(Grid).withConfig({
    componentId: "sc-88af1620-0"
})(_templateObject(), function(props) {
    return props.theme.normalizeStyles({
        marginBottom: 43
    });
});
var TemplatesHighilighted = function(props) {
    var popularTemplates = props.popularTemplates, navigationGroup = props.navigationGroup;
    var theme = useTheme();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                $my: 5,
                $variant: "h4",
                children: navigationGroup.title
            }),
            /*#__PURE__*/ _jsx(TemplatesNavGrid, {
                gutter: theme.header.grid.gutter,
                columns: [
                    null,
                    null,
                    2,
                    4,
                    6
                ],
                children: navigationGroup.items.map(function(i) {
                    return /*#__PURE__*/ _jsx(Grid.Column, {
                        columns: [
                            null,
                            null,
                            1,
                            2,
                            3
                        ],
                        children: /*#__PURE__*/ _jsx(SecondaryNavigationItem, {
                            path: i.path,
                            title: i.title,
                            description: i.description
                        }, i.title)
                    }, i.title);
                })
            }),
            /*#__PURE__*/ _jsx(Highlighted, _object_spread({}, popularTemplates))
        ]
    });
};
export default TemplatesHighilighted;
